export const APP_CONSTANTS = {
  COMPANY_LOCAL_STORAGE_KEY: "@clinisharp-company_id",
  AUTH_LOCAL_STORAGE_KEY: "@clinisharp-auth",
  AUTH_USER_LOCAL_STORAGE_KEY: "@clinisharp-auth-user",
  AUTH_ACCESS_TOKEN_LOCAL_STORAGE_KEY: "@clinisharp-access-token",
  UPGRADE_BANNER_LOCAL_STORAGE_KEY: "@clinisharp-upgrade-banner-dismissed",
  SIDEBAR_OPEN_LOCAL_STORAGE_KEY: "sidebar:open",
};
